
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import vuetifyToast from 'vuetify-toast';
import './TimetableInfoDialog.scss'
import Timetable from '@/components/Timetable/models/Timetable';
import moment from 'moment';
import { TimetableStates } from '@/components/Timetable/models/TimetableStates';
import { Destination } from '@/components/Passenger/models/Destination';

@Component({
    template: require("./TimetableInfoDialog.vue.html"),
    components: {
        
    }
})
export class TimetableInfoDialog extends Vue {
    static EVENT_TIMETABLE_INFO_DIALOG_OPEN = "EVENT_TIMETABLE_INFO_DIALOG_OPEN";

    show: boolean = false;
    timetable: Timetable = null;

    get destination(): Destination {
        return this.$store.state.destination.destinations.find(d => d.id === this.timetable.destinationId);
    }

    isValidDate(date: Date): boolean {
        return date?.getTime() > 946684800000;
    }

    formatDate(date: Date): string {
        return moment(date).locale(this.$i18n.locale()).format('LLL');
    }

    created(){
        this.$root.$on(TimetableInfoDialog.EVENT_TIMETABLE_INFO_DIALOG_OPEN, this.onOpenDialog)
    }

    onOpenDialog(timetable: Timetable){
        // console.log("TimetableInfoDialog", "onOpenDialog()", "timetable:", timetable);
        this.timetable = timetable;
        this.show = true;
    }

    onCloseClick() {
       this.show = false;
    }

    beforeDestroy(){
        this.$root.$off(TimetableInfoDialog.EVENT_TIMETABLE_INFO_DIALOG_OPEN, this.onOpenDialog)
    }
}

export default TimetableInfoDialog;
